export const globalConfig = {
    toast: {
        life: 5000,
    },
}
